export default "__VITE_ASSET___26wLxTZ__"